import React from 'react';
import {twMerge} from 'tailwind-merge';

interface BorderTextProps {
  text: string;
  className?: string;
  as?: React.ElementType;
}

const BorderText: React.FC<BorderTextProps> = ({text, className, as: Tag = 'span'}) => {
  const gradientStyles =
    'bg-clip-text text-transparent bg-[linear-gradient(to_right,#0041EA_0%,#FF31D2_76%,#FF398C_100%)]';

  const combinedClassName = twMerge(gradientStyles, className);
  const textClassName = twMerge('absolute top-0 left-0 text-white', className)
  return (
    <div className="relative inline-block">
      {/* Stroke gradient layer */}
      <Tag className={combinedClassName} style={{
        WebkitTextStroke: '4px #6B21FF',
      }}>{text}</Tag>

      {/* White fill text */}
      <Tag className={textClassName}>{text}</Tag>
    </div>
  );
};

export default BorderText;
